<div class="cart-skuba-recommends" *ngIf="items?.length">
  <h2>{{ 'SKUBA_RECOMMENDS' | translate }}</h2>
  <hr />
  <div class="slider-row">
    <div class="slider-box" *ngFor="let item of items">
      <a routerLink="/search/{{ item.skn }}" (click)="saveDashboardClick(item.id)">
        <div class="slider-image">
          <div class="image-placeholder" *ngIf="!item.showRealPicture">
            <h4>
              <i class="fas fa-camera"></i>
            </h4>
          </div>
          <img
            *ngIf="item.picture_url"
            src="{{ item.picture_url }}"
            [alt]="item.name"
            [hidden]="!item.showRealPicture"
            (load)="imageLoaded(item)">
        </div>
        <div class="slider-text">
          <h2 class="slider-text-h2">{{ item.name }}</h2>
          <p>SKN: {{ item.skn }}</p>
        </div>
      </a>
    </div>
  </div>
</div>
